module.exports = __webpack_public_path__ + "img/legalServices-15.1ab26d75.png";